import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../services/formateDate";
import { useBookmarks } from "../../../context/bookmarkContext";

const BookmarkCard = ({ creator_profile_id, slide, wishlist }) => {
  const accessToken = localStorage.getItem("@user");
  const { bookmarks, toggleBookmark } = useBookmarks();

  const handleNavigate = () => {};

  return (
    <div
      id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fae-3890e283"
      className="table-list-card"
    >
      <div className="text-5xl text-black"></div>
      <div className="property-image custom-bg _2">
        <div className="table-card-div">
          <div className="property-image-inner">
            <div className="p-image-inner-info-top">
              <div className="card-image-left-meta">
                {/* <p className="category">{slide?.category.name}</p> */}
              </div>
              <div className="card-image-left-meta">
                {/* {slide.bookmarks > 0 && (
                  <div className="text-block">{slide.bookmarks}</div>
                )} */}

                {/* {bookmarks.includes(slide.id) ? ( */}
              </div>
            </div>
          </div>
          <div
            id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbb-3890e283"
            onClick={handleNavigate}
            className="table-card-image w-inline-block"
          >
            <img
              loading="lazy"
              src={`https://high-table-2024.s3.ap-south-1.amazonaws.com/public/photo/tables/hd/${slide?.media}`}
              alt=""
              className="table-image-oncard placeholderimg"
            />
            <div className="card-overlay-grad" />
          </div>
        </div>
      </div>
      <div
        id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbd-3890e283"
        onClick={handleNavigate}
        className="card-details w-inline-block"
      >
        <div className="card-meta-datat">
          <div
            id="w-node-fcce1b21-3954-7070-54ad-f0ea51f92fbf-3890e283"
            className="location-div"
          >
            <div className="code-embed-4 location-icon-oncard w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="card-location feature-label">
              {slide && <>{formatDate(slide?.event_date)}</>}
            </div>
          </div>
          <div className="date-on-card">
            <div className="code-embed-4 date-icon-on-card w-embed">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={20}
                height={20}
                viewBox="0,0,256,256"
              >
                <g
                  fill="#e2b760"
                  fillRule="nonzero"
                  stroke="none"
                  strokeWidth={1}
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  strokeMiterlimit={10}
                  strokeDasharray=""
                  strokeDashoffset={0}
                  fontFamily="none"
                  fontWeight="none"
                  fontSize="none"
                  textAnchor="none"
                  style={{ mixBlendMode: "normal" }}
                >
                  <g transform="scale(5.33333,5.33333)">
                    <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                  </g>
                </g>
              </svg>
            </div>
            <div className="card-location feature-label">
              {slide?.city ? (
                <>
                  {slide?.city?.length > 13
                    ? `${slide.city.substring(0, 13)}...`
                    : slide.city}
                </>
              ) : (
                <>Bangalore</>
              )}
            </div>
          </div>
        </div>
        <div className="card-title clamptitle">{slide?.title}</div>
        <div className="text-sm">₹{slide.price} / per seat</div>
        <div className="card-meta-datat comapny-and-date">
          <div className="property-size property-company">
            <div className="host-dp">
              <img
                loading="lazy"
                src={
                  creator_profile_id?.photo
                    ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${creator_profile_id?.photo}`
                    : "https://as2.ftcdn.net/v2/jpg/03/31/69/91/1000_F_331699188_lRpvqxO5QRtwOM05gR50ImaaJgBx68vi.jpg"
                }
                alt=""
                className="host-image-on-card"
              />
            </div>
            <p className="host-name darkgrey">
              {" "}
              {creator_profile_id?.first_name}
              {creator_profile_id?.last_name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookmarkCard;
